import React, { Component } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';

import Loader from '../utils/Loadersmall';

class Refundpolicy extends Component {

    constructor(props) {
        super(props);
        this.state = {
            serviceCheck:false,
        }   
    }

    async componentDidMount() {
       
    }

    render() {

        // if(this.state.serviceCheck===false)
        // return (<Loader/>);

        return (

            <div class="ps-about">

                <div class="ps-about__content">
                    {/* <section class="ps-about__banner" data-background="assets/img/Mask-Group.jpg">
                        <div class="container">
                            <div class="ps-banner">
                                <h2 class="ps-banner__title">About Us</h2>
                                <div class="ps-banner__desc">Completely the needs of home medicine chest and professional offices</div><a class="ps-banner__shop" href="category-list.html">Shop now</a>
                            </div>
                        </div>
                    </section> */}
                    <section class="ps-about__project">
                        <div class="container-fluid">
                            <h2 class="ps-banner__desc text-center">Returns, Refunds, Cancellation and Exchange Policy</h2>
                            <section class="">
                                <div class="ps-section__content">
                                        
                                        <p class="ps-section__desc">Any cancellations, returns or exchange are governed by this policy ("Return Policy"). </p>

                                        <h4>1. Cancellations</h4>
                                        <p class="ps-section__desc">An order once placed cannot be cancelled. However, you may contact us on the store contact details for cancellation requests. Cancellation in such cases will be done at our sole discretion. Please email us at support@byos.in for any cancellation requests.</p> 

                                        <h4>2. Refunds</h4>
                                        <p class="ps-section__desc">If approved, then the refund will be processed a credit will automatically be applied to your credit card or original method of payment, within 15 days. In case of any delays or assistance, please contact us.</p>

                                        <h4>3. Returns</h4>
                                        <p class="ps-section__desc">If you think, you have received the product in a bad condition or if the packaging is tampered with or damaged before delivery, please refuse to accept the package and return the package to the delivery person. Also, please email us at support@BYOS.co mentioning your Order ID.</p>
                                        <p class="ps-section__desc">If you want to return the product after it has been delivered, please send us an email at support@BYOS.co within 48 hours of receipt of the product. You will need to send the product back to us at your own cost.</p>
                                        <br/>
                                        </div>
                            </section>
                        </div>
                    </section>
        
                </div>
            
            </div>
    
        );
    }
}

export default Refundpolicy;